module.exports = __webpack_public_path__ + "static/system-0a0ac7a76442c62821b28373845d7a93.png";